<script>
    export default {
        name: 'ModalTarget',
        props: {
            name: String,
        },
        created() {
            this.content = null
            portalModalInstance.$on(`update:${this.name}`, this.update)
        },
        beforeDestroy() {
            portalModalInstance.$off(`update:${this.name}`, this.update)
        },
        methods: {
            update(content) {
                this.content = content ? content : null
                this.$forceUpdate()
            }
        },
        render(h) {
            const children = this.content ? this.content : null
            const className = { [`modal-target-${this._uid}`]: true }
            return h('div', { class: className }, children)
        }
    }
</script>
